<div class="rate-table-scroll">
  @if (showRbaIndicators) {
    <div class="d-flex flex-row flex-wrap align-items-center bank-indicators rba-indicators">
      <strong>🇦🇺 RBA</strong>
      @if (year.rbaIndicators?.inflationTarget; as target) {
        <span>Inflation target {{ target.lowerBound }}–{{ target.upperBound }}%</span>
      }
      @if (year.rbaIndicators?.eggPriceIndex; as eggs) {
        <span>
          Eggs CPI {{ eggs.value }}
          <small>FY average · {{ eggs.quartersReported }}/4 quarters · {{ eggs.referenceBasePeriod }}</small>
        </span>
      }
      @if (year.rbaIndicators?.housePriceIndex; as houses) {
        <span>
          House index {{ houses.value }}
          <small>FY average · {{ houses.quartersReported }}/4 quarters · {{ houses.referenceBasePeriod }}</small>
        </span>
      }
    </div>
  }
  @if (showBcbIndicators) {
    <div class="d-flex flex-row flex-wrap align-items-center bank-indicators bcb-indicators">
      <strong>🇧🇷 BCB</strong>
      @if (year.bcbIndicators?.inflationTarget; as target) {
        <span>Inflation target {{ target.lowerBound }}–{{ target.upperBound }}%</span>
      }
      @if (year.bcbIndicators?.eggPriceIndex; as eggs) {
        <span>
          Eggs IPCA index {{ eggs.value }}
          <small>FY average · {{ eggs.monthsReported }}/12 months · {{ eggs.referenceBasePeriod }}</small>
        </span>
      }
      @if (year.bcbIndicators?.housePriceIndex; as houses) {
        <span>
          House index {{ houses.value }}
          <small>FY average · {{ houses.quartersReported }}/4 quarters · {{ houses.referenceBasePeriod }}</small>
        </span>
      }
    </div>
  }
  <div class="d-flex flex-row month-rate-table" role="table"
    [attr.aria-label]="'Policy rate and change by central bank for federal fiscal year ' + year.year">
    <div class="d-flex flex-column rate-col rate-col-bank">
      <span class="rate-head" role="columnheader">Bank</span>
      <span class="rate-subhead"></span>
      @for (row of rateRows; track row.bank) {
        <span [class]="'rate-cell bank-cell bank-' + bankClass(row.bank)"
          [style.color]="bankColor(row.bank)" [attr.title]="row.bank"
          role="rowheader">{{ bankName(row.bank) }}</span>
      }
      <span class="rate-foot" role="rowheader">Total</span>
    </div>

    @for (column of year.monthColumns; track column.month; let monthIndex = $index) {
      @let unscheduledMonth = hasEmergency(column);
      <div [class]="'d-flex flex-column rate-col month-' + column.month"
        [class.emergency]="unscheduledMonth">
        <span class="rate-head" role="columnheader">{{ column.label }}</span>
        <span class="d-flex flex-row rate-subhead">
          <span class="sub-rate">Rate</span>
          <span class="sub-change">Change</span>
          <span class="sub-date">Date</span>
          @if (unscheduledMonth) {
            <span class="sub-emergency" title="Unscheduled decisions">EMER</span>
          }
        </span>
        @for (row of rateRows; track row.bank) {
          @let move = monthChange(row.bank, column);
          <span [class]="'d-flex flex-row rate-cell bank-' + bankClass(row.bank) + ' month-' + column.month"
            [style.--bank-tint]="move ? bankTint(row.bank) : null"
            role="row">
            <span class="sub-rate" [class.blank]="!row.levels[monthIndex]" role="cell">
              {{ row.levels[monthIndex] ?? '—' }}
            </span>
            <span class="sub-change" role="cell"
              [class.increase]="move && move.points > 0" [class.decrease]="move && move.points < 0">
              {{ move ? move.label : '' }}
            </span>
            @let moved = changeDates(row.bank, column);
            <span class="sub-date" role="cell" [attr.title]="moved.title || null">{{ moved.label }}</span>
            @if (unscheduledMonth) {
              @let called = emergencyDates(row.bank, column);
              <span class="sub-emergency" role="cell"
                [attr.title]="called.title || null">{{ called.label }}</span>
            }
          </span>
        }
        @let net = monthNet(column);
        <span class="d-flex flex-row rate-foot" role="row">
          <span class="sub-rate" role="cell">{{ monthTotal(monthIndex) ?? '—' }}</span>
          <span class="sub-change" role="cell"
            [class.increase]="net && net.points > 0" [class.decrease]="net && net.points < 0">
            {{ net ? net.label : '' }}
          </span>
          <span class="sub-date" role="cell"></span>
          @if (unscheduledMonth) {
            <span class="sub-emergency" role="cell">{{ emergencyCount(column) }}</span>
          }
        </span>
      </div>
    }
  </div>
</div>
